import React, { useState, useEffect } from 'react';
import { getContents, createContent, updateContent } from '../../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import AboutForm from '../forms/AboutForm';
import toast from 'react-hot-toast';

const AboutModule = () => {
  const [aboutContent, setAboutContent] = useState(null);
  const [visionContent, setVisionContent] = useState(null);
  const [missionContent, setMissionContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeSubTab, setActiveSubTab] = useState('whoweare');
  const [editingItem, setEditingItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      // Using getContents which should point to /api/cms/contents
      const response = await getContents();
      console.log('About Module - Full Response:', response);
      
      // Handle different response formats
      let allContents = [];
      if (Array.isArray(response)) {
        allContents = response;
      } else if (response.data && Array.isArray(response.data)) {
        allContents = response.data;
      } else if (response.success && response.data && Array.isArray(response.data)) {
        allContents = response.data;
      }
      
      console.log('All Contents:', allContents);
      
      // Find specific content by sectionId
      const about = allContents.find(c => c.sectionId === 'about');
      const vision = allContents.find(c => c.sectionId === 'vision');
      const mission = allContents.find(c => c.sectionId === 'mission');
      
      console.log('Found About:', about);
      console.log('Found Vision:', vision);
      console.log('Found Mission:', mission);
      
      setAboutContent(about || null);
      setVisionContent(vision || null);
      setMissionContent(mission || null);
      
      if (!about && !vision && !mission) {
        console.log('No about content found in database');
      }
    } catch (error) {
      console.error('Error fetching about content:', error);
      toast.error('Error fetching about content');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item, type) => {
    setEditingItem(item);
    setActiveSubTab(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingItem(null);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      {/* Sub Tabs */}
      <div style={{ display: 'flex', gap: '0.5rem', borderBottom: '1px solid #E2E8F0', marginBottom: '2rem', flexWrap: 'wrap' }}>
        <button 
          onClick={() => setActiveSubTab('whoweare')} 
          style={{ 
            padding: '0.6rem 1.2rem', 
            background: activeSubTab === 'whoweare' ? '#2C7A7B' : 'transparent', 
            color: activeSubTab === 'whoweare' ? 'white' : '#5A6E7F', 
            border: 'none', 
            borderRadius: '8px 8px 0 0', 
            cursor: 'pointer', 
            fontWeight: 500,
            fontSize: '0.9rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
        >
          <span>🏢</span> Who We Are
          {aboutContent && <span style={{ marginLeft: '0.5rem', fontSize: '0.7rem', background: '#2C7A7B20', padding: '0.2rem 0.4rem', borderRadius: '4px' }}>✓</span>}
        </button>
        <button 
          onClick={() => setActiveSubTab('vision')} 
          style={{ 
            padding: '0.6rem 1.2rem', 
            background: activeSubTab === 'vision' ? '#2C7A7B' : 'transparent', 
            color: activeSubTab === 'vision' ? 'white' : '#5A6E7F', 
            border: 'none', 
            borderRadius: '8px 8px 0 0', 
            cursor: 'pointer', 
            fontWeight: 500,
            fontSize: '0.9rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
        >
          <span>👁️</span> Our Vision
          {visionContent && <span style={{ marginLeft: '0.5rem', fontSize: '0.7rem', background: '#2C7A7B20', padding: '0.2rem 0.4rem', borderRadius: '4px' }}>✓</span>}
        </button>
        <button 
          onClick={() => setActiveSubTab('mission')} 
          style={{ 
            padding: '0.6rem 1.2rem', 
            background: activeSubTab === 'mission' ? '#2C7A7B' : 'transparent', 
            color: activeSubTab === 'mission' ? 'white' : '#5A6E7F', 
            border: 'none', 
            borderRadius: '8px 8px 0 0', 
            cursor: 'pointer', 
            fontWeight: 500,
            fontSize: '0.9rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
        >
          <span>🎯</span> Our Mission
          {missionContent && <span style={{ marginLeft: '0.5rem', fontSize: '0.7rem', background: '#2C7A7B20', padding: '0.2rem 0.4rem', borderRadius: '4px' }}>✓</span>}
        </button>
      </div>

      {/* Who We Are Section */}
      {activeSubTab === 'whoweare' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <h3 style={{ color: '#0A192F', fontSize: '1.2rem', marginBottom: '0.25rem' }}>Who We Are</h3>
              <p style={{ color: '#5A6E7F', fontSize: '0.85rem' }}>Company overview and introduction</p>
            </div>
            <button 
              onClick={() => handleEdit(aboutContent, 'whoweare')} 
              style={{ 
                padding: '0.5rem 1rem', 
                background: aboutContent ? '#F5A623' : '#2C7A7B', 
                color: 'white', 
                border: 'none', 
                borderRadius: '8px', 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <i className={`fas ${aboutContent ? 'fa-edit' : 'fa-plus'}`} />
              {aboutContent ? 'Edit Who We Are' : 'Add Who We Are'}
            </button>
          </div>

          {aboutContent ? (
            <div style={{ 
              background: 'white', 
              padding: '1.5rem', 
              borderRadius: '12px', 
              borderLeft: '4px solid #2C7A7B', 
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
              <h4 style={{ color: '#0A192F', marginBottom: '0.5rem', fontSize: '1.1rem' }}>{aboutContent.title || 'Who We Are'}</h4>
              {aboutContent.subtitle && (
                <p style={{ color: '#2C7A7B', marginBottom: '1rem', fontSize: '0.9rem', fontWeight: 500 }}>{aboutContent.subtitle}</p>
              )}
              <div style={{ color: '#5A6E7F', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
                {aboutContent.content}
              </div>
              {aboutContent.imageUrl && (
                <img 
                  src={aboutContent.imageUrl.startsWith('http') ? aboutContent.imageUrl : `http://localhost:5000${aboutContent.imageUrl}`} 
                  alt="About" 
                  style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'cover', borderRadius: '8px', marginTop: '1rem' }} 
                />
              )}
              <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #E2E8F0', display: 'flex', gap: '1rem', fontSize: '0.8rem', color: '#94A3B8' }}>
                <span><i className="fas fa-clock" /> Updated: {new Date(aboutContent.updatedAt).toLocaleString()}</span>
                <span style={{ color: aboutContent.isActive ? '#10B981' : '#EF4444' }}>
                  {aboutContent.isActive ? '● Active' : '● Inactive'}
                </span>
              </div>
            </div>
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '3rem', 
              background: '#F7F9FC', 
              borderRadius: '16px', 
              border: '2px dashed #E2E8F0'
            }}>
              <i className="fas fa-building" style={{ fontSize: '3rem', color: '#CBD5E1', marginBottom: '1rem' }} />
              <p style={{ color: '#5A6E7F', marginBottom: '1rem' }}>No "Who We Are" content configured yet</p>
              <button 
                onClick={() => handleEdit(null, 'whoweare')} 
                style={{ padding: '0.5rem 1rem', background: '#2C7A7B', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
              >
                Create Content
              </button>
            </div>
          )}
        </div>
      )}

      {/* Vision Section */}
      {activeSubTab === 'vision' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <h3 style={{ color: '#0A192F', fontSize: '1.2rem', marginBottom: '0.25rem' }}>Vision Statement</h3>
              <p style={{ color: '#5A6E7F', fontSize: '0.85rem' }}>Our long-term vision and goals</p>
            </div>
            <button 
              onClick={() => handleEdit(visionContent, 'vision')} 
              style={{ 
                padding: '0.5rem 1rem', 
                background: visionContent ? '#F5A623' : '#2C7A7B', 
                color: 'white', 
                border: 'none', 
                borderRadius: '8px', 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <i className={`fas ${visionContent ? 'fa-edit' : 'fa-plus'}`} />
              {visionContent ? 'Edit Vision' : 'Add Vision'}
            </button>
          </div>

          {visionContent ? (
            <div style={{ 
              background: 'white', 
              padding: '1.5rem', 
              borderRadius: '12px', 
              textAlign: 'center',
              borderLeft: '4px solid #2C7A7B', 
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
              <i className="fas fa-eye" style={{ fontSize: '2.5rem', color: '#2C7A7B', marginBottom: '1rem' }} />
              <h4 style={{ color: '#0A192F', marginBottom: '0.5rem' }}>{visionContent.title || 'Our Vision'}</h4>
              <p style={{ fontSize: '1.1rem', fontStyle: 'italic', color: '#5A6E7F', lineHeight: '1.6' }}>
                "{visionContent.content}"
              </p>
              {visionContent.imageUrl && (
                <img 
                  src={visionContent.imageUrl.startsWith('http') ? visionContent.imageUrl : `http://localhost:5000${visionContent.imageUrl}`} 
                  alt="Vision" 
                  style={{ maxWidth: '100%', maxHeight: '150px', objectFit: 'cover', borderRadius: '8px', marginTop: '1rem' }} 
                />
              )}
              <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #E2E8F0', fontSize: '0.8rem', color: '#94A3B8' }}>
                Updated: {new Date(visionContent.updatedAt).toLocaleString()}
              </div>
            </div>
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '3rem', 
              background: '#F7F9FC', 
              borderRadius: '16px', 
              border: '2px dashed #E2E8F0'
            }}>
              <i className="fas fa-eye" style={{ fontSize: '3rem', color: '#CBD5E1', marginBottom: '1rem' }} />
              <p style={{ color: '#5A6E7F', marginBottom: '1rem' }}>No vision statement configured yet</p>
              <button 
                onClick={() => handleEdit(null, 'vision')} 
                style={{ padding: '0.5rem 1rem', background: '#2C7A7B', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
              >
                Create Vision
              </button>
            </div>
          )}
        </div>
      )}

      {/* Mission Section */}
      {activeSubTab === 'mission' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <h3 style={{ color: '#0A192F', fontSize: '1.2rem', marginBottom: '0.25rem' }}>Mission Statement</h3>
              <p style={{ color: '#5A6E7F', fontSize: '0.85rem' }}>Our mission and core values</p>
            </div>
            <button 
              onClick={() => handleEdit(missionContent, 'mission')} 
              style={{ 
                padding: '0.5rem 1rem', 
                background: missionContent ? '#F5A623' : '#2C7A7B', 
                color: 'white', 
                border: 'none', 
                borderRadius: '8px', 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <i className={`fas ${missionContent ? 'fa-edit' : 'fa-plus'}`} />
              {missionContent ? 'Edit Mission' : 'Add Mission'}
            </button>
          </div>

          {missionContent ? (
            <div style={{ 
              background: 'white', 
              padding: '1.5rem', 
              borderRadius: '12px', 
              borderLeft: '4px solid #2C7A7B', 
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
              <i className="fas fa-bullseye" style={{ fontSize: '2rem', color: '#2C7A7B', marginBottom: '1rem' }} />
              <h4 style={{ color: '#0A192F', marginBottom: '0.5rem' }}>{missionContent.title || 'Our Mission'}</h4>
              <div style={{ color: '#5A6E7F', lineHeight: '1.6' }}>
                {missionContent.content && missionContent.content.includes('•') ? (
                  <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                    {missionContent.content.split('\n').map((line, idx) => {
                      const cleanLine = line.replace('•', '').trim();
                      return cleanLine && <li key={idx} style={{ marginBottom: '0.5rem' }}>{cleanLine}</li>;
                    })}
                  </ul>
                ) : (
                  <p>{missionContent.content}</p>
                )}
              </div>
              {missionContent.imageUrl && (
                <img 
                  src={missionContent.imageUrl.startsWith('http') ? missionContent.imageUrl : `http://localhost:5000${missionContent.imageUrl}`} 
                  alt="Mission" 
                  style={{ maxWidth: '100%', maxHeight: '150px', objectFit: 'cover', borderRadius: '8px', marginTop: '1rem' }} 
                />
              )}
              <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #E2E8F0', fontSize: '0.8rem', color: '#94A3B8' }}>
                Updated: {new Date(missionContent.updatedAt).toLocaleString()}
              </div>
            </div>
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '3rem', 
              background: '#F7F9FC', 
              borderRadius: '16px', 
              border: '2px dashed #E2E8F0'
            }}>
              <i className="fas fa-bullseye" style={{ fontSize: '3rem', color: '#CBD5E1', marginBottom: '1rem' }} />
              <p style={{ color: '#5A6E7F', marginBottom: '1rem' }}>No mission statement configured yet</p>
              <button 
                onClick={() => handleEdit(null, 'mission')} 
                style={{ padding: '0.5rem 1rem', background: '#2C7A7B', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
              >
                Create Mission
              </button>
            </div>
          )}
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <AboutForm 
          editingItem={editingItem} 
          type={activeSubTab} 
          onClose={handleCloseModal} 
          onRefresh={fetchData} 
        />
      )}
    </div>
  );
};

export default AboutModule;